<template>
	<div id="confirmationTake">
		<div class="row">
			<div class="col-12 pb-3 pl-3 pl-md-3 pr-3 pr-md-3">
				<div class="col-12 bg-outline-purple bg-purple-light rounded pt-2 pb-2">
					<div class="text-purple font-size-11 text-capitalize"><i class="fas fa-exclamation-circle mr-2"></i>Harap Mengisikan Alasan Pembatalan Order Yang Masuk Ke Mobile Counter Anda</div>
				</div>
			</div>
			<div class="col-12 col-lg-5 col-md-12 pb-3 pl-0 pl-md-3 pr-1 pr-md-3 pt-2">
				<div class="row">
					<div class="col-12 col-md-12">
						Alasan Pembatalan
					</div>
				</div>
				<div class="row">
					<div class="col-8 col-md-12 pt-2">
						<textarea type="text" name="" @input="setcancelReason(reason)" v-model="reason" class="form-control form-control-sm box-purple"> </textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
	data() {
		return {
			reason: ''
		}
	},
	methods: {
		...mapMutations('transactionList', ['setcancelReason'])
	}
}
</script>